/// <amd-dependency path='VSS/LoaderPlugins/Css!WorkItemArea' />

import * as React from "react";
import { registerLWPComponent } from "VSS/LWP";
import * as TestPlanSettingsDialog from "../Scenarios/OnDemandTestRun/ControllerViews/TestPlanSettingsDialog";
import * as TCMContracts from "TFS/TestManagement/Contracts";
import { TestPlanSettingsActionsCreator } from "TestManagement/Scripts/Scenarios/OnDemandTestRun/Actions/TestPlanSettingsActionsCreator";
import { TestPlanSettingsActionsHub } from "TestManagement/Scripts/Scenarios/OnDemandTestRun/Actions/TestPlanSettingsActionsHub";
import { TestPlanSettingsSource } from "TestManagement/Scripts/Scenarios/OnDemandTestRun/Sources/TestPlanSettingsSource";
import { TestPlanSettingsStore } from "TestManagement/Scripts/Scenarios/OnDemandTestRun/Stores/TestPlanSettingsStore";

export interface TestPlanSettingsDialogProps {
    selectedPlan: any;
    onCloseDialog?: () => void;
    onSaveCallback?: (testPlan: TCMContracts.TestPlan) => void;
}

// This is a proxy component for test plan settings dialog using LegacyComponent
class TestPlanSettingsDialogProxy extends React.Component<TestPlanSettingsDialogProps, {}> {
    public render(): React.ReactNode {
        return <div />;
    }

    public componentDidMount(): void {
        let container = document.createElement("div");

        const actionsHub = new TestPlanSettingsActionsHub();
        const source = new TestPlanSettingsSource();
        const testPlanSettingsStore = new TestPlanSettingsStore(actionsHub);
        const testPlanSettingsActionsCreator = new TestPlanSettingsActionsCreator(actionsHub, source);
        testPlanSettingsActionsCreator.populateTestPlanSettingsOptions(this.props.selectedPlan);

        let testPlanSettingProps: TestPlanSettingsDialog.ITestPlanSettingsProps = {
            selectedPlan: this.props.selectedPlan,
            actionsCreator: testPlanSettingsActionsCreator,
            store: testPlanSettingsStore,
            onCloseDialog: this.props.onCloseDialog,
            onSaveCallback: this.props.onSaveCallback
        };

        if (this.props.selectedPlan.buildId) {
            testPlanSettingProps.selectedPlan.build = { id: this.props.selectedPlan.buildId.toString() } as TCMContracts.ShallowReference;
        }

        TestPlanSettingsDialog.renderDialog(container, testPlanSettingProps);
    }
}

registerLWPComponent("testplan-settings-dialog-proxy", TestPlanSettingsDialogProxy);
